import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  ConfirmDialogComponent,
  ConfirmDialogResult,
} from '@dash/randy/shared/components/confirm-dialog/confirm-dialog.component';

@Directive({
    selector: '[appConfirmDialog]',
    standalone: false
})
export class ConfirmDialogDirective {
  @Input() title: string = null;
  @Input() message: string = null;
  @Input() password: string = null;
  @Input() showDeleteContents = false;
  @Output() afterConfirm = new EventEmitter<ConfirmDialogResult>();

  constructor(public dialog: MatDialog) {}

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    event.stopPropagation();
    event.preventDefault();
    event.stopImmediatePropagation();
    let dialog = this.dialog.open(ConfirmDialogComponent, {
      data: {
        title: this.title,
        message: this.message,
        password: this.password,
        showDeleteContents: this.showDeleteContents,
      },
    });
    dialog.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this.afterConfirm.emit(result);
      }
    });
  }
}
